import React from 'react';
import { TextInputField, Textarea, Button, Pane, majorScale, Heading, toaster } from 'evergreen-ui';
import { ConfirmIcon, CrossIcon } from 'evergreen-ui';
import { updateAnnouncement } from '../services/announcementServices';
import FileUploaderMultipleUploadDemo from '../commons/FileUploaderMultipleUploadDemo';

const EditAnnouncementForm = ({ editedAnnouncement, setEditedAnnouncement, handleCancelEdit, fetchAnnouncements, userId, isDirector, setAnnouncements }) => {

    const [removedAttachments, setRemovedAttachments] = React.useState([]);

        const getExistingAttachments = () => {
        if (!editedAnnouncement) return [];
        const a = editedAnnouncement.attachments;
        if (Array.isArray(a)) return a;
        if (typeof a === 'string' && a.trim() !== '') {
            try {
                const parsed = JSON.parse(a);
                return Array.isArray(parsed) ? parsed : [];
            } catch (err) {
                console.error('Errore nel parsing della stringa di allegati:', err, a);
                return [];
            }
        }
        return [];
    };

    const existingAttachments = getExistingAttachments();
    
    const handleRemoveAttachment = (attachmentName) => {
        const updatedAttachments = (Array.isArray(existingAttachments) ? existingAttachments : [])
            .filter(att => {
                const cand = (att && (att.name || att.file_name || att.fileName || att.file || att)) || '';
                return String(cand) !== String(attachmentName);
            });
        setEditedAnnouncement({ ...editedAnnouncement, attachments: updatedAttachments });
        setRemovedAttachments([...removedAttachments, attachmentName]);
     };

    const handleConfirmEdit = async () => {
        try {
            const formData = new FormData();
            formData.append('title', editedAnnouncement.title);
            formData.append('body', editedAnnouncement.body);
            formData.append('announcement_id', editedAnnouncement.id);

            const allAttachments = [
                ...(editedAnnouncement.attachments || []),
                ...(editedAnnouncement.newAttachments || []),
            ];
        
            allAttachments.forEach((attachment, index) => {
                if (attachment.file) {
                    formData.append(`attachments[${index}]`, attachment.file);
                }
            });
        
            if (removedAttachments.length > 0) {
                formData.append('remove_attachments', JSON.stringify(removedAttachments));
            }

            const resultUpdate = await updateAnnouncement(formData);
            if (resultUpdate.status === 'success') {
                const updatedAnnouncements = await fetchAnnouncements();
                setAnnouncements(updatedAnnouncements?.data ?? []);
                toaster.success('Annuncio modificato con successo.');
                handleCancelEdit();
            } else {
                toaster.danger('Errore durante l\'aggiornamento dell\'annuncio.');
            }
        } catch (error) {
            console.error('Errore nella modifica dell\'annuncio:', error);
            toaster.danger('Errore nella modifica dell\'annuncio.');
        }
    };

    const handleFilesChange = (acceptedFiles) => {
        const newAttachments = acceptedFiles.map(file => ({ name: file.name, file }));
        setEditedAnnouncement((prev) => ({
            ...prev,
            newAttachments: [...(prev.newAttachments || []), ...newAttachments],
        }));
    };

    return (
        <Pane>
            <Heading size={600} marginBottom={16}>
                Modifica annuncio
            </Heading>
            <TextInputField
                label="Titolo"
                value={editedAnnouncement.title}
                onChange={(e) => setEditedAnnouncement({ ...editedAnnouncement, title: e.target.value })}
                marginBottom={16}
            />
            <Textarea
                label="Corpo"
                value={editedAnnouncement.body}
                onChange={(e) => setEditedAnnouncement({ ...editedAnnouncement, body: e.target.value })}
                marginBottom={16}
                resize="none"
                height={120}
            />
            <Pane>
                <Heading size={500} marginBottom={8}>Allegati esistenti</Heading>
                {Array.isArray(existingAttachments) && existingAttachments.length > 0 ? (
                    existingAttachments
                        .map((attachment) => {
                            if (!attachment) return null;
                            if (typeof attachment === 'string') {
                                const s = attachment.trim();
                                if (s.startsWith('http')) {
                                    return { name: s.split('/').pop(), url: s };
                                }
                                return { name: s };
                            }
                            if (typeof attachment === 'object') {
                                const url = attachment.url || attachment.file_url || null;
                                const name = attachment.name || attachment.file_name || (url ? url.split('/').pop() : null);
                                if (!name) return null;
                                return { name, url };
                            }
                            return null;
                        })
                        .filter(Boolean)
                        .filter(att => att.name && String(att.name).trim() !== '')
                        .map((attachment, index) => (
                            <Pane key={index} display="flex" alignItems="center" marginBottom={8}>
                                <span>{attachment.name}</span>
                                <Button intent="danger" marginLeft={8} onClick={() => handleRemoveAttachment(attachment.name)}>
                                    Rimuovi
                                </Button>
                            </Pane>
                        ))
                ) : (
                    <Pane marginBottom={8}><em>Nessun allegato presente</em></Pane>
                )}
                <Heading size={500} marginBottom={8}>Nuovi allegati</Heading>
                <FileUploaderMultipleUploadDemo onFilesChange={handleFilesChange} />
            </Pane>
            <Pane display="flex" justifyContent="space-between" marginTop={majorScale(2)}>
                <Button appearance="primary" intent="success" onClick={handleConfirmEdit}>
                    Conferma modifica <ConfirmIcon marginLeft={8} />
                </Button>
                <Button intent="danger" onClick={handleCancelEdit}>
                    Annulla <CrossIcon marginLeft={8} />
                </Button>
            </Pane>
        </Pane>
    );
};

export default EditAnnouncementForm;